export default __webpack_public_path__ + "static/media/burger-menu.7a2f65e1.svg";